/**
 * 자주 쓰는 빈 객체 & 값들.
 */

/**
 * 빈 Array.
 */
export const EMPTY_ARRAY = [] as const;

/**
 * 빈 object.
 */
export const EMPTY_OBJECT = {} as const;

/**
 * 빈 함수.
 */
export const noopCallback = () => {};

/**
 * 빈 Async 함수.
 */
export const noopAsyncCallback = async () => {};

/**
 * null 리턴 함수.
 */
export const nullCallback = () => null;

/**
 * input 인자 그대로 리턴합니다.
 */
export const passCallback = <T>(val: T) => val;

/**
 * input 인자 그대로 리턴합니다.
 */
export const passAsyncCallback = async <T>(val: T) => val;
